module.exports = __webpack_public_path__ + "static/android-icon-192x192-1606106f1b70a1db52eacb0e2ca130db.png";